module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shoes-d7689bcc3765aee78b60a6508b0b0da3.svg";